
import { GDT, DatasetTypes } from "@/types";
import { storeToRefs } from "pinia";
import { useBooks } from "@/services";
import { computed, defineComponent, onMounted } from "vue";
import MeasurementSelection from "@/components/modals/BookUploaderModal/MeasurementSelection.vue";
import { contexts } from "@/constants";
import { useOrgSettings } from "@/services";

export default defineComponent({
  name: "FileMetadata",
  components: {
    MeasurementSelection,
  },
  setup() {
    const books = useBooks();
    const { dataSetDefinition } = storeToRefs(books);
    const hasUniqueId = computed(() => books.hasUniqueId);
    const hasAddress = computed(() => books.hasAddress);
    const isMetaDataValid = computed(() => books.isMetaDataValid);
    const businessNames = useOrgSettings().businessLines.map((a) => a.name);

    const datasetType = Object.keys(DatasetTypes);
    const typeOptions = Object.keys(GDT.PropertyType)
      .map((x: string) => (GDT.PropertyType as any)[x])
      .filter((x) => typeof x === "string");

    onMounted(() => {
      if (dataSetDefinition.value) {
        dataSetDefinition.value.name = dataSetDefinition.value?.name.replace(
          ".csv",
          ""
        );
      }
    });

    return {
      contexts,
      typeOptions,
      datasetType,
      businessNames,
      dataSetDefinition,
      isMetaDataValid,
      hasUniqueId,
      hasAddress,
    };
  },
});
